import { memo } from "react";
import { RemoveScroll as RS } from "react-remove-scroll";
import { jsx } from "react/jsx-runtime";
const RemoveScroll = memo((props) => props.children ? /* @__PURE__ */ jsx(RS, { ...props }) : null), classNames = RS.classNames;
export {
  RemoveScroll,
  classNames
};
